import React, { Fragment } from "react";
import { staticURLs } from "../../config/urls";
import TransunionLogo from "../../Assets/images/logo_transunion.png";
import ExperianLogo from "../../Assets/images/logo_experian.png";
import EquifaxLogo from "../../Assets/images/logo_equifax.png";
import { useTranslation } from "react-i18next";
import CreditAccordion from "./CreditAccordion";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const FreezeMyCredit = () => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const handleRedirect = (e: any, freezeType: string) => {
        e.preventDefault();
        window.open(freezeType, "_blank");
    };

    const getCreditBureauLogo = (bureau: string) => {
        bureau = bureau.toLowerCase();
        let creditBureauLogo;
        switch (bureau) {
            case "transunion":
                creditBureauLogo = TransunionLogo;
                break;
            case "experian":
                creditBureauLogo = ExperianLogo;
                break;
            case "equifax":
                creditBureauLogo = EquifaxLogo;
                break;
        }

        return creditBureauLogo;
    };

    const creditFaqDescription = (i: number) => {
        switch (i) {
            case 1:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>{tLang("freezeMyCredit.faqWidget.whatIsCreditFreezeQuestion.para1")}</p>
                                <p>{tLang("freezeMyCredit.faqWidget.whatIsCreditFreezeQuestion.para2")}</p>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>{tLang("freezeMyCredit.faqWidget.differenceCreditFreezeFraudAlert.para1")}</p>
                                <p>{tLang("freezeMyCredit.faqWidget.differenceCreditFreezeFraudAlert.para2")}</p>
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>{tLang("freezeMyCredit.faqWidget.creditFreezeEffectCreditScore.para1")}</p>
                            </div>
                        </div>
                    </div>
                );
            case 4:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>{tLang("freezeMyCredit.faqWidget.liftAFreeze.para1")}</p>
                            </div>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };
    const faqContent = [
        {
            id: 1,
            name: tLang("freezeMyCredit.faqWidget.whatIsCreditFreezeQuestion.question"),
            content: creditFaqDescription(1),
        },
        {
            id: 2,
            name: tLang("freezeMyCredit.faqWidget.differenceCreditFreezeFraudAlert.question"),
            content: creditFaqDescription(2),
        },
        {
            id: 3,
            name: tLang("freezeMyCredit.faqWidget.creditFreezeEffectCreditScore.question"),
            content: creditFaqDescription(3),
        },
        {
            id: 4,
            name: tLang("freezeMyCredit.faqWidget.liftAFreeze.question"),
            content: creditFaqDescription(4),
        },
    ];
    return (
        <React.Fragment>
            <div className="row" id="content">
                <div className="col-xs-12">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <em className="las la-snowflake"></em>
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{tLang("freezeMyCredit.howDoIPlaceFreezeWidget.title")}</h2>
                                </div>
                            </div>
                            <div className="box-description">
                                <p>{tLang("freezeMyCredit.howDoIPlaceFreezeWidget.actionMessage")}</p>
                            </div>
                            <div className="box-actions"></div>
                        </div>

                        <div className="box-content">
                            <div className="credit-freeze-options margin-bottom-l">
                                <div className="row around-sm">
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="credit-bureau-tile">
                                            <div className="credit-bureau-tile-title sr-only">
                                                <h3>TransUnion</h3>
                                            </div>
                                            <div className="credit-bureau-tile-logo">
                                                <img src={getCreditBureauLogo("transunion")} alt="TransUnion Logo" />
                                            </div>
                                            <div className="credit-bureau-tile-button">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary"
                                                    onClick={(e: any) => {
                                                        handleRedirect(e, staticURLs.transUnionCreditFreeze);
                                                        window.addToDataLayer({ event: "Manage Freeze with TransUnion" });
                                                    }}
                                                >
                                                    <span className="btn-text">
                                                        {tLang("freezeMyCredit.howDoIPlaceFreezeWidget.manageFreezeButtonText")}
                                                        <span className="sr-only">with TransUnion</span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="credit-bureau-tile">
                                            <div className="credit-bureau-tile-title sr-only">
                                                <h3>Experian</h3>
                                            </div>
                                            <div className="credit-bureau-tile-logo">
                                                <img src={getCreditBureauLogo("experian")} alt="Experian Logo" />
                                            </div>
                                            <div className="credit-bureau-tile-button">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary"
                                                    onClick={(e: any) => {
                                                        handleRedirect(e, staticURLs.experianCreditFreeze);
                                                        window.addToDataLayer({ event: "Manage Freeze with Experian" });
                                                    }}
                                                >
                                                    <span className="btn-text">
                                                        {tLang("freezeMyCredit.howDoIPlaceFreezeWidget.manageFreezeButtonText")}
                                                        <span className="sr-only">with Experian</span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="credit-bureau-tile">
                                            <div className="credit-bureau-tile-title sr-only">
                                                <h3>Equifax</h3>
                                            </div>
                                            <div className="credit-bureau-tile-logo">
                                                <img src={getCreditBureauLogo("equifax")} alt="Equifax Logo" />
                                            </div>
                                            <div className="credit-bureau-tile-button">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary"
                                                    onClick={(e: any) => {
                                                        handleRedirect(e, staticURLs.equifaxCreditFreeze);
                                                        window.addToDataLayer({ event: "Manage Freeze with Equifax" });
                                                    }}
                                                >
                                                    <span className="btn-text">
                                                        {tLang("freezeMyCredit.howDoIPlaceFreezeWidget.manageFreezeButtonText")}
                                                        <span className="sr-only">with Equifax</span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="msg-generic  msg-small">
                                <RenderIcons iconName="info-circle" />
                                {tLang("freezeMyCredit.howDoIPlaceFreezeWidget.instructionMessage")}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-no-gutter ">
                    <div className="row ">
                        <div className="col-xs-12 col-sm-8">
                            <div className="box">
                                <div className="box-content">
                                    <CreditAccordion
                                        headers={faqContent.map((v: any, i: number) => (
                                            <Fragment key={`${v.id}-${i}`}>{v.name}</Fragment>
                                        ))}
                                        content={faqContent.map((v: any, i: number) => (
                                            <Fragment key={v.id}>{v.content}</Fragment>
                                        ))}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <div className="box">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon position-right" aria-hidden="true">
                                            <RenderIcons iconName="lightbulb" />
                                        </div>
                                        <div className="box-title-text">
                                            <h3 className="box-title">{tLang("freezeMyCredit.tipsWidget.title")}</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-content">
                                    <ul className="list-default">
                                        <li>{tLang("freezeMyCredit.tipsWidget.tip1")}</li>
                                        <li>{tLang("freezeMyCredit.tipsWidget.tip2")}</li>
                                        <li>{tLang("freezeMyCredit.tipsWidget.tip3")}</li>
                                        <li>{tLang("freezeMyCredit.tipsWidget.tip4")}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default FreezeMyCredit;
